import {
  TRANSPORT,
  MESSAGE,
  SETSTATE,
  SELECT,
  DESELECT,
  RESET_SELECTION,
} from "../actions/types";
import without from "lodash/without";

const INITIAL_STATE = {
  transporter: null,
  selections: [],
  message: "",
  vidModal: false,
  greetingPopup: false,
  timer: "Yes",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TRANSPORT:
      return { ...state, ...action.payload };
    case SETSTATE:
      return { ...state, ...action.payload };

    case MESSAGE:
      return { ...state, ...action.payload };
    //
    case SELECT:
      return { ...state, selections: [...state.selections, action.payload] };
    case DESELECT:
      return {
        ...state,
        selections: without(state.selections, action.payload),
      };

    case RESET_SELECTION:
      return { ...state, selections: [] };
    //
    default:
      return state;
  }
};
